import { Api } from './net';

/*
 * PostJson
 * Post
 * Get
 * Export
 */
const apiList = {

	/**
	 *模块名: {
	 *    方法名: [接口名, 参数1, 参数2, ………]
	 *}
	 */

	// 已迁移：module/common.js
	Common: {
		getThirdToken: ["Post", 'common/get-third-token'], // 获取提供给第三方的运营商token
		codeSend: ["Post", 'client/1/common/phone-verification-code-send', 'phone'], // 发送验证码
		codeCheck: ["Post", 'client/1/common/phone-verification-code-check', 'phone', 'code'], // 验证验证码
	},
	// 已迁移：module/user.js
	User: {
		// 三类账户登录
		login: ["Post", 'user/login', 'username', 'password'],
		operatorLogin: ["Post", 'operator/login', 'username', 'password'],
		settlementLogin: ["Post", 'clearing-account/login', 'username', 'password'],

		list: ["Post", 'user/list', 'type', 'nickname', 'page', 'phone'], // 客户端用户 的列表
		detailByPhone: ["Post", 'user/detail-by-phone', 'phone'], // 客户端的用户详情
		listByPhone: ["Post", 'user/list', 'phone'], // 通过手机号查找 客户端的用户列表
		detail: ["Post", 'user/find-user', 'user_id'], // 客户端的用户详情
		detailByPhone: ["Post", 'user/detail-by-phone', 'phone'], // 客户端的用户详情
		delete: ["Post", 'user/delete-user', 'user_id'],
		create: ["Post", 'user/create', 'phone'],

		orderList: ["Post", 'order/list', 'user_id', 'page', 'begin_time', 'end_time'], // 通过用户ID找订单列表
		virtualCardList: ["Post", 'virtual-card/list', 'user_id', 'page', 'begin_time', 'end_time'], // 通过用户ID找卡片
	},
	// 统计 | 已迁移：module/stat.js
	Stat: {
		home: ["Post", 'stat-new/home', 'operator_id', 'org_id', 'station_id'], // 首页数据

		// stat_type  1-日   2-周   3-月   4-年
		income: ["Post", 'stat-new/income-stat', 	      'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 单独值
		orderCount: ["Post", 'stat-new/order-count-stat',     'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 统计订单数量 表
		energyConsumed: ["Post", 'stat-new/energy-consumed-stat', 'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 统计电量消耗 表
		payMethod: ["Post", 'stat-new/pay-method-stat',      'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 统计支付方式 表
		userActive: ["Post", 'stat-new/user-active-stat',     'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 统计用户活跃度 表
		moneyCount: ["Post", 'stat-new/order-income-stat',    'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 统计订单数量 表 - 用在B端
		stationIncomeRank: ["Post", 'stat-new/station-rank', 	  'stat_type', 'time', 'begin_time', 'end_time', 'page', 'org_id'], // 统计充电站排行
		// orgStation: ['stat-new/org-list-stat', 'page', 'name', 'create_time', 'order_type' ], // 片区列表by营收统计 - 用在B端

		getClearingTradeItemIncomeCustom: ["Post", 'stat-new/get-clearing-trade-item-income-custom',    'stat_type', 'time', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id'], // 营收金额曲线  -- 流水金额

		// 使用率排行
		// orgRank: ['org/list', 'page', 'sort', 'operator_id'],
		// stationRank: ['station/list', 'page', 'sort', 'operator_id', 'org_id'],
		operatorRank: ["Post", 'stat-new/stat-operator-rank', 'stat_order_by'],
		orgRank: ["Post", 'stat-new/stat-org-rank', 'stat_order_by', 'operator_id'],
		stationRank: ["Post", 'stat-new/stat-station-rank', 'stat_order_by', 'operator_id', 'org_id'],

		// 效率统计
		efficie: ["Post", 'stat-day-data/detail', 'time', 'target_type', 'target_id'],
		// 效率统计 - 旧
		arpu: ["Post", 'stat-new/get-arpu', 'time', 'operator_id', 'org_id', 'station_id'],
		usage: ["Post", 'stat-new/get-usage', 'time', 'operator_id', 'org_id', 'station_id'],

		// 统计报表
		deviceIncrease: ["Post", 'stat-new/device-new-stat', 'time', 'operator_id', 'org_id', 'station_id'], // 设备日增量
		offLineByType: ["Post", 'stat-new/device-offline-stat'], // 设备离线数 - 设备类型
		offLineByOper: ["Post", 'stat-new/operator-device-offline-stat'], // 设备离线数 - 营运商
		offLineHistory: ["Post", 'stat-new/history-device-offline-stat', 'stat_type', 'time'], // 历史设备离线数

		alarmCount: ["Post", 'stat-new/alarm-stat', 'operator_id', 'begin_time', 'end_time'], // 告警数量统计
		// usageRank:  ['stat-new/usage-rate-rank-stat', 'operator_id'],  // 使用率排行
		amountRank: ["Post", 'stat-new/device-count-rank-stat', 'operator_id'], // 设备数量排行

		testData: ["Post", 'stat-new/test-data'], // 测试数据

		cardStatHome: ["Post", 'stat-new/card-stat-home', 'operator_id'],

		cardStatDataBoard: ["Post", 'stat-new/card-stat-data-board', 'org_ids', 'product_type', 'card_type', 'begin_time', 'end_time', 'operator_id'],

		// 语音通知服务 TODO
		voiceNoticeStat: ["Post", 'stat-new/voice-notice-stat'],
		voiceNoticeList: ["Post", 'stat-new/voice-notice-list', 'page', 'page_size', 'operator_id'],
		voiceNoticePurchase: ["Post", 'stat-new/voice-notice-purchase', 'quantity', 'total_price'],

		// 权益包增值服务统计
		benefitPackageSummary: ["Post", 'stat-new/benefit-package-summary', 'operator_id'],
		benefitPackageSummaryGrouped: ["Post", 'stat-new/benefit-package-summary-grouped', 'page', 'page_size'],

		// 直流桩成功率统计
		statOrderListGroup: ["Post", 'stat-new/stat-finish-code-order-list-group', 'page', 'operator_id', 'org_id', 'station_id', 'begin_time', 'end_time'], // 结束原因统计列表
		listByFinishCode: ["Post", 'stat-new/list-by-finish-code', 'page', 'operator_id', 'org_id', 'station_id', 'begin_time', 'end_time', 'finish_code', 'user_id'],
		failOrderStat: ["Post", 'stat-new/fail-order-stat', 'operator_id', 'org_id', 'station_id', 'begin_time', 'end_time', 'finish_code'], // 异常订单数统计
		failOrderAnalysis: ["Post", 'stat-new/fail-order-analysis', 'page', 'finish_code', 'rank_type', 'begin_time', 'end_time'], // 失败订单数排行

	},
	// 地图相关统计 | 已迁移：module/stat.js
	MapStat: {
		count: ["Post", 'account-money/account-stat', 'stat_type', 'time', 'clearing_account_id'], // 单独值
		statMapArea: ["Post", 'stat-new/stat-map-area', 'province', 'city'], // 单独值
		queryStation: ["Post", 'stat-new/query-station-list-by-county', 'city', 'county'],
	},
	// 分账账户统计 | 已迁移：module/stat.js
	SettleAccountStat: {
		count: ["Post", 'account-money/account-stat',       'stat_type', 'time', 'begin_time', 'end_time', 'clearing_account_id'], // 单独值
		lineData: ["Post", 'account-money/account-count-stat', 'stat_type', 'time', 'begin_time', 'end_time', 'clearing_account_id'], // 折线图
	},
	// 已迁移：module/common.js
	Export: {
		device: ["Post", 'device/export-device-list', 'user_id', 'station_id', 'gateway_id', 'uid', 'suid'], // 导出设备
		charging: ["Post", 'export-task/create-order-export', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id', 'status', 'clearing_status', 'pay_method', 'finish_code', 'alipay_shualan_type', 'gateway_uid', 'user_name', 'user_phone', 'device_type', 'socket_uid', 'outer_sn', 'finish_begin_time', 'finish_end_time', 'clearing_begin_time', 'clearing_end_time', 'flag_vip'], // 导出充电订单

		// recharge: ['charge-order/export', 'begin_time', 'end_time', 'org_id', 'charge_type', 'clearing_status', 'status', 'pay_method'], // 导出充值订单
		recharge: ["Post", 'export-task/create-charge-order-export', 'begin_time', 'end_time', 'refund_begin_time', 'refund_end_time', 'operator_id', 'org_id', 'status', 'pay_method', 'clearing_status', 'user_name', 'card_uid', 'user_phone', 'charge_type', 'flag_vip'], // 导出充值订单
		insurance: ["Post", 'insurance/export', 'page', 'begin_time', 'end_time'],
		venueInsurance: ["Post", 'insurance/export-operator', 'page' ],

		statement: ["Post", 'export-task/create-statement-export', 'operator_id', 'type', 'flag_vip', 'begin_time', 'end_time'], // 导出对账单

		/* 支付宝广告订单 = 支付宝红包 */
		alipayAdOrder: ["Post", 'export-task/alipay-ad-order-export-task/create', 'begin_time', 'end_time', 'operator_id', 'status'],
	},
	// 已迁移：module/common.js
	ExportTask: {
		list: ["Post", 'export-task/list', 'page', 'page_size', 'types', 'status'], // 导出任务列表
		delete: ["Post", 'export-task/delete', 'id'],
	},

	// 已迁移：module/user.js
	UserRuleLog : {  // 用户规则日志
		list: ["Post", 'user-rule-log/list', 'phone', 'page'],
	},
	// 已迁移：module/user.js
	UserRule : {  // 用户规则
		list: ["Post", 'user-rule/list', 'phone', 'name', 'mode', 'page'],
		delete: ["Post", 'user-rule/delete', 'id'],
		save: ["Post", 'user-rule/save', 'id', 'phone', 'name,', 'operator_id', 'org_id', 'mode', 'config'],
		findByPhone: ["Post", 'user-rule/find-by-phone', 'org_id', 'user_id'],
		updateUsername: ["Post", 'user-rule/update-username', 'phone', 'org_id', 'username'],
		deleteBatch: ["Post", 'user-rule/delete-batch', 'ids'],  // 批量移除折扣规则
		batchUpdate: ["Post", 'user-rule/update-batch', 'ids', 'mode', 'config', 'free_time', 'flag_car_user_rule', 'flag_user_rule'],  // 批量修改
	},

	// 权限 | 已迁移：module/user.js
	Authority: {
		listByUser: ["Post", 'authority/list-by-user'],
		listByRole: ["Post", 'authority/list-by-role', 'user_id', 'user_type', 'purpose'],
		listByUserRole: ["Post", 'authority/list-by-user-role', 'user_id', 'user_type'],

		roleList: ["Post", 'authority/role/list'],
		saveRole: ["Post", 'authority/role/save', 'id', 'key', 'name'],
		saveRoleAuthority: ["Post", 'authority/role-authority/save', 'role_id', 'authority_ids'],
		saveUserAuthority: ["Post", 'authority/user-authority/save', 'user_id', 'user_type', 'authority_ids'],
		deleteRole: ["Post", 'authority/role/delete', 'id'],
	},
	// 管理员 | 已迁移：module/user.js
	Admin: {
		register: ["Post", 'admin/register', 'username', 'password'],
		list: ["Post", 'admin/list', 'page'],
		detail: ["Post", 'admin/detail', 'admin_id'],
		delete: ["Post", 'admin/delete', 'admin_id'],
		actionList: ["Post", 'admin/get-admin-action', 'page', 'user_id', 'begin_time', 'end_time'],
		updatePassword: ["Post", 'admin/update-password', 'admin_id', 'old_password', 'new_password'],
		resetPassword: ["Post", 'admin/update-member-password', 'user_id', 'new_password'],

		setUserBindPhone: ["Post", 'operator/set-user-bind-phone', 'operator_id', 'flag_force_bind_phone'],
	},
	// 运营商 | 已迁移：module/operator.js
	Operator: {
		list: ["Post", 'user/operator-list', 'page', 'username', 'phone'],
		listAll: ["Post", 'user/operator-list-all', 'username'], // 下拉选择用 运营商列表 - 所有包括子运营商
		listAllMain: ["Post", 'user/operator-list-all', 'username'], // 下拉选择用 运营商列表 - 仅主运营商  ??
		subList: ["Post", 'operator/sub-operator-list'], // 下级运营商 （下拉选择用）(平台方调用就仅返回一级运营商)
		create: ["Post", 'operator/create', 'username', 'name', 'phone', 'password', 'avatar', 'gender', 'province', 'city', 'county', 'real_name', 'pay_config', 'admin_logo', 'admin_name', 'app_name', 'app_contact', 'company_name', 'mode'],
		detail: ["Post", 'operator/detail', 'operator_id'],
		detailById: ["Post", 'operator/detail-by-id', 'operator_id'],

		check: ["Post", 'operator/check', 'username', 'phone'],
		uidCheck: ["Post", 'operator/check-uid-is-empty'], // 历史遗留问题：有部分运营商没有user.uid 调用本接口 生成并返回运营商详情
		findParentList: ["Post", 'operator/find-parent-list'],

		refreshToken: ["Post", 'operator/refresh-token'],
		resetPassword: ["Post", 'operator/reset-password', 'operator_id', 'password'],
		changePassword: ["Post", 'operator/change-password', 'password'],
		changePhone: ["Post", 'operator/update-phone', 'id', 'phone'],
		findBackPassword: ["Post", 'operator/find-back-password', 'username', 'phone', 'code', 'new_pwd'],

		changeLoginName: ["Post", 'operator/update/operator-username', 'operator_id', 'new_username'],

		servicePay: ["Post", 'operator/service-charge/pay', 'operator_id', 'money'], // 平台收取服务费

		setAdFlag: ["Post", 'operator/set-enable-ad', 'operator_id', 'org_ids', 'flag_ad'], // 设置广告开关

		setOrderSerRateFlag: ["Post", 'operator/set-operator-service-rate', 'operator_id'], // 设置 订单服务费抽成 开关
		setOrderSerRate: ["Post", 'operator/set-commission-rate', 'target_id', 'commission_rate', 'order_service_fee_max_money', 'order_service_fee_min_money'], // 设置 订单服务费抽成 配置

		setSerFeeChannel: ["Post", 'operator/set-pay-service-fee-channel', 'id', 'channel'], // 设置服务费订单服务费抽成 缴纳方式

		gathAccount: ["Post", 'account/collect-account-detail', 'user_id'], // 获取服务费收款账户详情
		checkHaluo: ["Post", 'station/check-flag-hl'], // 获取(当前登录的)运营商下有无开启哈啰推送的站点

		setPayChannel: ["Post", 'operator/change-pay-channel', 'id', 'channel'], // 设置第三方支付渠道
		pre_recharge_enable: ["Post", 'user/enable-pre-recharge', 'operator_id'], // 开启关闭预充值
		flag_bf_pay: ["Post", 'operator/set-operator-bf-pay', 'operator_id'], // 开启关闭宝付支付
		flag_insurance: ["Post", 'operator/set-operator-insurance', 'operator_id'], // 开启关闭泰山保险·安心充电
		// flag_check_customer_service_phone: ['operator/set-operator-customer-service-phone', 'operator_id'], // 开启关闭 片区联系方式校验
		flag_check_customer_service_phone: ["Post", 'operator/set-flag-operator-customer-service-phone', 'operator_id'], // 开启关闭 片区联系方式校验
		flag_real_id_verify: ["Post", 'operator/set-operator-real-id', 'operator_id'], // 开启关闭 换电柜实名认证
		flag_qgl_pay: ["Post", 'operator/set-operator-qgl-pay', 'operator_id'], // 开启关闭 青橄榄一卡通支付
		set_qgl_config: ["Post", 'operator/set-qgl-config', 'id', 'qgl_config'], // 设置 青橄榄一卡通支付
		flag_hello: ["Post", 'operator/set-operator-hl', 'id'], // 开启关闭 哈啰推送
		set_hl_config: ["Post", 'operator/set-operator-hl-config', 'id', 'config'], // 设置 运营商哈啰配置
		report_hello: ["Post", 'operator/report-to-hello', 'id'], // 设置 运营商重新推送
		flag_card_global_available: ["Post", 'operator/set-flag-card-global-available', 'operator_id'], // 开启关闭 卡片通用

		set_report_strategy: ["Post", 'operator/set-report-strategy', 'id', 'report_strategy', 'report_config'], // 运营商推送设置

		changePayChannel: ["Post", 'operator/change-pay-channel', 'id', 'channel'], // 变更支付渠道
		setFlagIndependentWxService: ["Post", 'operator/set-flag-independent-wx-service', 'operator_id'], // 服务号对接定制开关
		setFlagIndependentWxMp: ["Post", 'operator/set-flag-independent-wx-mp', 'operator_id'], // 服务号对接定制开关

        setFlagBfPostpay: ["Post", 'operator/set-flag-bf-postpay', 'operator_id'], // 先充后付开关
        closeFlagInvoice: ["Post", 'operator/close-flag-invoice', 'operator_id'], // 关闭运营商片区 flag_invoice
        closeFlagMemberPrice: ["Post", 'operator/close-flag-member-price', 'operator_id'], // 关闭运营商片区站点 flag_member_price
        closeRefundApplication: ["Post", 'operator/close-user-apply-refund', 'operator_id'], // 关闭运营商片区 flag_user_apply_refund
		closeFlagCarOccupyAfterCharge: ["Post", 'operator/close-flag-car-occupy-after-charge', 'operator_id'], // 关闭占位计费
        checkMultiChargeConfig: ["Post", 'operator/check-multi-charge-config', 'operator_id'], // 检查运营商是否配置双计费
        clearMultiChargeConfig: ["Post", 'operator/clear-multi-charge-config', 'operator_id'], // 清除运营商双计费模版中第二个模版的配置
	},
	// 子运营商 | 已迁移：module/operator.js
	SubOperator: {
		list: ["Post", 'operator/sub-account-list', 'page', 'name', 'operator_id'],
		save: ["Post", 'operator/save-sub-account', 'id', 'username', 'password', 'phone', 'alipay_account', 'mode', 'operator_id'],
		delete: ["Post", 'operator/delete-sub-account', 'sub_account_id'],
		setStatus: ["Post", 'operator/set-account-status', 'sub_account_id', 'status'],
		editPwd: ["Post", 'operator/account-change-password', 'sub_account_id', 'password'],

		allotOrg: ["Post", 'org/distribution', 'operator_member_id', 'org_ids', 'operator_id'], // 向子账号分配片区
		allotAccount: ["Post", 'clearing-account/distribution', 'target_operator_id', 'clearing_account_ids', 'operator_id'], // 向子账号分配分账账户
		subList: ["Post", 'operator/sub-operator-list', 'operator_id', 'name', 'page'],

		// 获取 子运营商 当前被分配的 片区或分账账号 列表
		orgList: ["Post", 'org/get-sub-org', 'operator_id', 'page'],
		settlementList: ["Post", 'clearing-account/get-sub-clearing-account', 'operator_id', 'page'],

		// 移除 子运营商 当前被分配的 片区或分账账号
		orgRemove: ["Post", 'org/distribution-delete', 'operator_id', 'operator_member_id', 'org_ids'],
		settlementRemove: ["Post", 'clearing-account/distribution-delete', 'operator_id', 'target_operator_id', 'clearing_account_ids'],
	},
	// 运营商定制信息 | 已迁移：module/operator.js
	OperatorCustom: {
		save: ["Post", 'operator-custom/save', 'operator_custom_id', 'operator_id', 'company_name', 'admin_name', 'admin_logo', 'app_name', 'app_contact', 'after_pay_redirect_url'],
		detail: ["Post", 'operator-custom/detail-by-operator-id', 'operator_id'],
		delete: ["Post", 'operator-custom/delete', 'operator_custom_id'],

		// 信息展示定制开关
		setFlagAdmin: ["Post", 'operator-custom/set-flag-admin', 'operator_id'],
	},
	// 运营商广告定制 | 已迁移：module/operator.js
	OperatorAd: {
		save: ["Post", 'operator-ad-config/save', 'operator_id', 'after_wx_h5_pay_redirect_url', 'after_ali_h5_pay_redirect_url', 'after_wx_mini_program_pay_redirect_url', 'after_ali_mini_program_pay_redirect_url'],
		detail: ["Post", 'operator-ad-config/detail', 'operator_id'],

		// 支付后跳转链接定制开关
		setFlagAfterPayRedirectUrl: ["Post", 'operator-ad-config/set-flag-after-pay-redirect-url', 'operator_id'],
	},
	// 运营商独立商户配置 | 已迁移：module/operator.js
	OperatorPay: {
		enable: ["Post", 'operator-pay-config/update-operator-independent-pay', 'operator_id'], // 开启关闭独立商户配置
		detail: ["Post", 'operator-pay-config/detail', 'operator_id'],
		save: ["Post", 'operator-pay-config/save', 'operator_id', 'name', 'wx_mch_type', 'flag_wx_independent', 'wx_independent_app_id', 'wx_mch_id', 'wx_pay_key' /* , 'wx_pay_v3_key', 'wx_pay_cert_serial_no' */, 'wx_cert_path' /* , 'wx_private_cert_path', 'wx_private_key_path' */, 'alipay_app_id', 'alipay_private_key', 'alipay_public_key', 'alipay_cert_path', 'alipay_public_cert_path', 'alipay_root_cert_path', 'alipay_transfer_config',],
		setFjnxConfig: ["Post", 'operator-pay-config/set-fjnx-config', 'operator_id'], // 保存南平农商行配置

		// 开户资料（暂未开放，接口定义保留勿删，恢复开户资料功能时可直接使用）
		merchantAccountSave: ["Post", 'operator-pay-config/account-opening/save', 'operator_id', 'legal_person_name', 'legal_person_id_no', 'legal_person_phone', 'legal_person_id_card_front', 'legal_person_id_card_back', 'business_license', 'unified_social_credit_code', 'account_name', 'bank_account_no', 'bank_name', 'bank_branch_name', 'bank_branch_code'],
		ocrBusinessLicense: ["Post", 'operator-pay-config/ocr/business-license', 'img_url'],
	},
	// 运营商独立商户配置 -- 微信支付分 | 已迁移：module/operator.js
	OperatorPayScore: {
		list: ["Post", 'wx-pay-score-account-application/list', 'page', 'page_size', 'operator_id'],
		apply: ["Post", 'wx-pay-score-account-application/apply', 'id', 'operator_pay_config_id'],
		query: ["Post", 'wx-pay-score-account-application/query', 'id'],
		detail: ["Post", 'wx-pay-score-account-application/detail', 'id'],
	},
	// 运营商客户端定制 | 已迁移：module/operator.js
	OperatorClient: {
		detail: ["Post", 'app/detail', 'id'],
		wxAppletSave: ["Post", 'app/save-wx-mini-program', 'id', 'operator_id', 'app_id', 'app_secret'],
		wxOfficialSave: ["Post", 'app/save', 'id', 'operator_id', 'type', 'wx_service_title', 'flag_independent_wx_service', 'wx_service_app_id', 'wx_service_app_secret', 'wx_service_qr_code_path', 'flag_wx_service_follow', 'wx_service_start_template_id', 'wx_service_finish_template_id', 'wx_service_order_stop_template_id', 'wx_service_order_refund_template_id', 'wx_service_close_cabinet_door_template_id', 'wx_service_insurance_pay_template_id', 'wx_service_insurance_refund_template_id'],
	},
	// 微信公众号文件 | 已迁移：module/operator.js
	OperatorWxFile: {
		save: ["Post", 'wx-file/save', 'operator_id', 'wx_service_file_name', 'wx_service_file_content'],
		detail: ["Post", 'wx-file/detail', 'operator_id'],
	},
	// 短信模版 | 已迁移：module/operator.js
	OperatorSms: {
		save: ["Post", 'app/save-sms', 'operator_id', 'sms_json'],
		detail: ["Post", 'app/sms-detail', 'operator_id'],
	},
	// 运营商激活码 | 已迁移：module/operator.js
	OperatorActivationCode: {
		list: ["Post", 'operator-activation-code/list', 'status', 'page'],
		create: ["Post", 'operator-activation-code/create', 'count', 'mode', 'flag_grant_all_auth'],
	},
	// 已迁移：module/operator.js
	WhiteList: {
		// 免费用户
		save: ["Post", 'white-panel/save', 'user_id', 'username', 'operator_id', 'org_id', 'user_type'],
		list: ["Post", 'white-panel/list', 'page', 'phone', 'username', 'operator_id', 'org_id', 'user_type'],
		delete: ["Post", 'white-panel/delete', 'id'],
		deleteBatch: ["Post", 'white-panel/delete-batch', 'ids'],
		updateUsername: ["Post", 'white-panel/update-username', 'id', 'username'], // 修改白名单用户名

		actionList: ["Post", 'white-panel/action-list', 'operator_id', 'org_id', 'user_id', 'page'], // 黑名单操作记录
	},
	// 已迁移：module/device.js
	DeviceWhite: {
		// 设备插口 超级白名单
		addUser: ["Post", 'white-panel/save-white-panel-device', 'device_uid', 'port_index', 'user_id', 'flag_free'],
		addCard: ["Post", 'white-panel/save-white-panel-card', 'device_uid', 'port_index', 'card_no', 'flag_free'],
		removeUser: ["Post", 'white-panel/remove-device-white-panel', 'device_uid', 'port_index', 'user_id'],
		removeCard: ["Post", 'white-panel/remove-device-white-panel', 'device_uid', 'port_index', 'card_no'],

		detail: ["Post", 'white-panel/white-panel-device', 'type', 'device_uid', 'port_index'], // type 1:用户 2:卡片
		setFree: ["Post", 'white-panel/set-device-white-panel', 'type', 'device_uid', 'port_index', 'flag_free'],
	},
	// 计费模版 | 已迁移：module/operator-model.js
	ChargeModel: {
		list: ["Post", 'charge-config/list', 'user_id', 'mode_type'],
		listByOperator: ["Post", 'charge_config/list', 'user_id', 'mode_type'],
		detail: ["Post", 'charge-config/detail', 'charge_config_id'],
		detailByOperator: ["Post", 'charge_config/detail', 'charge_config_id'],
		delete: ["Post", 'charge-config/delete', 'charge_config_id'],
		deleteByOperator: ["Post", 'charge_config/delete', 'charge_config_id'],

		create: ["Post", 'charge-config/save', 'user_id', 'charge_config_id', 'sp', 'name', 'mode', 'list', 'flag_show_charge_detail', 'unit_name', 'min_money', 'custom_money', 'service_fee_mode', 'service_charge_min', 'service_charge_max', 'occupy_list', 'occupy_free_minute', 'deposit', 'exchange_mode', 'min_consume_money', 'flag_gate_enable', 'charge_pre_occupy_fee_config', 'charge_finish_occupy_fee_config',],
		createByOperator: ["Post", 'charge_config/save', 'user_id', 'charge_config_id', 'sp', 'name', 'mode', 'list', 'flag_show_charge_detail', 'unit_name', 'min_money', 'custom_money', 'service_fee_mode', 'service_charge_min', 'service_charge_max', 'occupy_list', 'occupy_free_minute', 'deposit', 'exchange_mode', 'min_consume_money', 'flag_gate_enable', 'charge_pre_occupy_fee_config', 'charge_finish_occupy_fee_config',],
	
		listByOrg: ["Post", 'org/list-by-charge-config', 'page', 'charge_config_id', 'org_name'],
		listByStation: ["Post", 'station/list-by-charge-config', 'page', 'charge_config_id', 'station_name'],

		occupyListByStation: ["Post", 'station/list-by-occupy-charge-config', 'page', 'charge_config_id', 'station_name'], // 查询使用该占位计费模版  站点
		occupyListByOrg: ["Post", 'org/list-by-occupy-charge-config', 'page', 'charge_config_id', 'org_name'], // 查询使用该占位计费模版  片区
	},
	// 分账模版 | 已迁移：module/operator-model.js
	SettlementModel: {
		save: ["Post", 'clearing-config/save', 'json', 'service_fee_account_id'],
		detail: ["Post", 'clearing-config/detail', 'clearing_config_id'],
		delete: ["Post", 'clearing-config/delete', 'clearing_config_id'],

		list: ["Post", 'clearing-config/list', 'operator_id'],
		listByOperator: ["Post", 'clearing-config/list', 'station_operator_id'],

		chargeListByOrg: ["Post", 'org/list-by-clearing-config', 'page', 'clearing_config_id', 'org_name'], // 充电分账[片区]
		rechargeListByOrg: ["Post", 'org/list-by-recharge-clearing-config', 'page', 'recharge-clearing_config_id', 'org_name'], // 充值分账
		chargeListByStation: ["Post", 'station/list-by-clearing-config', 'page', 'clearing_config_id', 'station_name'], // 充电分账[站点]
		chargeFeeList: ["Post", 'clearing-config/list-by-energy-clearing-config', 'page', 'clearing_config_id', 'name', 'target_type'], // 充电电费分账[target_type => 1: 片区 2: 站点]

		energyListByStation: ["Post", 'station/list-bind-by-energy-clearing-config', 'page', 'clearing_config_id', 'name'], // 查询使用该电费分账模版  站点
		energyListByOrg: ["Post", 'org/list-bind-by-energy-clearing-config', 'page', 'clearing_config_id', 'name'], // 查询使用该电费分账模版  片区
	},
	// 卡充值模版 | 已迁移：module/operator-model.js
	CardModel: {
		list: ["Post", 'resource-package-config/list-by-operator-id', 'operator_id', 'type'],

		save: ["Post", 'resource-package-config/save', 'operator_id', 'resource_json'],
		delete: ["Post", 'resource-package-config/delete', 'resource_package_config_id', 'flag_force'], // flag_force: 1 => '继续删除'
		detail: ["Post", 'resource-package-config/detail', 'resource_package_config_id'],

		detailByOrgId: ["Post", 'resource-package-config/detail-by-org-id', 'org_id'],
		
		listByOrg: ["Post", 'org/list-by-recharge-config', 'page', 'recharge_config_id', 'recharge_car_config_id', 'org_name', ],
	},
	// 设置 片区配置或充电站配置 | 已迁移：module/org-station.js
	OperatorConfig: {
		detailByOrgId: ["Post", 'operator-config/detail', 'org_id'],
		detailByStationId: ["Post", 'operator-config/detail', 'station_id'],

		flag_ad: ["Post", 'operator-config/set-enable-ad', 'operator_config_id', 'org_id', 'flag_ad'], // 设置banner广告开关
		flag_ad_after_pay: ["Post", 'operator-config/set-flag-ad-after-pay', 'operator_config_id', 'org_id', 'flag_ad_after_pay'], // 设置支付后广告开关

		setStationIndependentConfig: ["Post", 'operator-config/set-station-independent-config', 'station_id'], // 是否开启充电站个性化

		// 能否付款
		qrcode_enable: ["Post", 'operator-config/set-enable-qrcode', 'operator_config_id'],
		qrcode_enable_all: ["Post", 'operator-config/set-qrcode-enable', 'operator_config_id'],
		wx_enable: ["Post", 'operator-config/enable-wx', 'operator_config_id'],
		alipay_enable: ["Post", 'operator-config/enable-alipay', 'operator_config_id'],
		wx_pay_score_enable: ["Post", 'operator-config/enable-wx-pay-score', 'operator_config_id'],
		flag_bf_pay: ["Post", 'operator-config/set-bf-pay', 'operator_config_id'],
		virtual_card_enable: ["Post", 'operator-config/set-enable-virtual-card', 'operator_config_id'],
		virtual_package_card_enable: ["Post", 'operator-config/set-enable-virtual-package-card', 'operator_config_id'],
		pay_message: ["Post", 'operator-config/set-pay-message', 'operator_config_id', 'pay_message'], // 支付页定制消息

		// 卡片能否多开
		flag_card_multiple_order: ["Post", 'operator-config/set-card-multiple-order', 'operator_config_id'],
		flag_package_card_multiple_order: ["Post", 'operator-config/set-package-card-multiple-order', 'operator_config_id'],
		flag_virtual_card_multiple_order: ["Post", 'operator-config/set-virtual-package-card-multiple-order', 'operator_config_id'],

		// 卡能否充值
		recharge_enable: ["Post", 'operator-config/set-recharge-enable', 'operator_config_id'],
		card_charge_enable: ["Post", 'operator-config/enable-card-charge', 'operator_config_id'],
		package_card_charge_enable: ["Post", 'operator-config/enable-package-card-charge', 'operator_config_id'],
		virtual_card_charge_enable: ["Post", 'operator-config/enable-virtual-card-charge', 'operator_config_id'],
		virtual_package_card_charge_enable: ["Post", 'operator-config/enable-virtual-package-card-charge', 'operator_config_id'],

		// 模版绑定
		bind_charge: ["Post", 'operator-config/bind-charge-config-id', 'operator_config_id', 'charge_config_id'],
		bind_charge_settle: ["Post", 'operator-config/bind-clearing-config', 'operator_config_id', 'clearing_config_id'],
		bind_card_settle: ["Post", 'operator-config/bind-recharge-clearing-config', 'operator_config_id', 'clearing_config_id'],
		bind_time: ["Post", 'operator-config/bind-resource-package-config', 'operator_config_id', 'resource_package_config_id'],
		bind_money_plug: ["Post", 'operator-config/bind-recharge-config', 'operator_config_id', 'recharge_config_id', 'recharge_config_mode', 'recharge_config_start_time', 'recharge_config_finish_time'],
		bind_money_car: ["Post", 'operator-config/bind-car-recharge-config', 'operator_config_id', 'recharge_config_id', 'recharge_car_config_mode', 'recharge_car_config_start_time', 'recharge_car_config_finish_time'],

		// 充值模版解绑
		unbind_recharge_config: ["Post", 'operator-config/unbind-recharge-config', 'operator_config_id', 'recharge_config_id'],
		// 充值模版批量绑定片区
		recharge_batch_bind_org: ["Post", 'operator-config/recharge-config-batch-bind-org', 'recharge_config_id', 'operator_config_ids'],
		
		// 计费模版批量绑定片区
		charge_batch_bind_org: ["Post", 'org/batch-bind-org-charge-config', 'charge_config_id', 'org_ids'],
		// 计费模版批量绑定站点
		charge_batch_bind_station: ["Post", 'operator-config/batch-bind-charge-config', 'charge_config_id', 'station_ids'],

		// 结算策略 - 消费退款
		refund_qrcode: ["Post", 'operator-config/auto-refund-qrcode', 'operator_config_id', 'auto_refund_qrcode', 'auto_refund_min_money_qrcode'],
		refund_card: ["Post", 'operator-config/set-auto-refund-mini-money-card', 'operator_config_id', 'auto_refund_card', 'auto_refund_min_money_card'],
		refund_virtual_card: ["Post", 'operator-config/auto-refund-virtual-card', 'operator_config_id', 'auto_refund_virtual_card', 'auto_refund_min_money_virtual_card'],

		// 结算策略 - 免费
		free_low_energy: ["Post", 'operator-config/set-free-low-energy', 'operator_config_id', 'flag_enable', 'free_low_energy_threshold'],
		free_low_power: ["Post", 'operator-config/set-free-low-power',  'operator_config_id', 'flag_enable', 'free_low_power_threshold'],
		free_charge_time: ["Post", 'operator-config/set-free-charge-time', 'operator_config_id', 'is_enable', 'free_charge_time'],

		charge_full_close: ["Post", 'operator-config/set-over-charge-close-order', 'operator_config_id', 'flag_enable', 'power_threshold', 'power_duration', 'zero_power_report_count'],

		// 电费结算
		setElectricCharge: ["Post", 'operator-config/set-electric-charge', 'operator_config_id', 'is_enable', 'energy_price', 'energy_ratio', 'flag_energy_charge_clearing', 'energy_charge_clearing_config_id'],

		// 限制时段禁止充电
		setDisableCharge: ["Post", 'operator-config/set-disable-charge', 'operator_config_id', 'flag_enable', 'disable_charge_mode', 'disable_charge_begin_time', 'disable_charge_end_time'],

		// 充满自停
		chargeFull: ["Post", 'operator-config/update-charge-full-enable', 'id', 'charge_full_enable', 'charge_full_money', 'charge_full_money_min'],
		
		// 关闭语音播报
		setVoiceConfig: ["Post", 'operator-config/set-voice-config', 'operator_config_id', 'flag_voice', 'config'],

		// 片区开票申请服务
		setInvoice: ["Post", 'operator-config/set-invoice', 'operator_config_id', 'flag_invoice'],
		// 设置占位模版
		setOccupyChargeConfig: ["Post", 'operator-config/set-occupy-charge-config', 'operator_config_id', 'flag_car_occupy_after_charge', 'occupy_charge_config_id'],
        // 设置会员充电折扣
        setMemberPriceConfig: ["Post", 'operator-config/set-member-price-config', 'operator_config_id', 'is_enable', 'member_price_config'],
		// 充值退款申请服务
		setRefundApplication: ["Post", 'operator-config/set-flag-user-apply-refund', 'operator_config_id', 'flag_user_apply_refund'],
		// 设置VIN码充电开关
		setFlagVinCharge: ["Post", 'operator-config/set-flag-vin-charge', 'operator_config_id', 'flag_vin_charge'],
    },

	// 已迁移：module/account.js
	AdminAccount: { // 平台收款账户
		detail: ["Post", 'account/detail-of-platform'], // 获取平台账户详情
		update: ["Post", 'account/update', 'id', 'pay_config'], // 编辑平台收款账户
		platformTransferOut: ["Post", 'account/platform-transfer-out', 'money'], // 平台账户提现
	},
	// 已迁移：module/marketing.js
	MarketingAccount: { // 平台营销账户
		detail: ["Post", 'account/ad-account-stat'], // 获取平台账户详情

		moneyByTime: ["Post", 'account/stat-alipay-account-money-by-time', 'id', 'begin_time', 'end_time'], // 获取平台账户详情

		operate: ["Post", 'account/alipay-ad-account-operate', 'id', 'type', 'money'],
		orderList: ["Post", 'alipay-ad-order/list', 'page', 'id', 'biz_id', 'order_sn', 'order_type', 'status', 'user_id', 'begin_time', 'end_time', 'use_begin_time', 'use_end_time'],
		orderDetail: ["Post", 'alipay-ad-order/detail-by-power-order', 'order_id', 'order_type'],
	},
	// 已迁移：module/account.js
	ClearingAccount: { // 分账账户
		// save: ['clearing-account/save', 'clearing_account_id', 'name', 'pay_config', 'phone', 'operator_id', 'pay_method'],
		save: ["Post", 'clearing-account/save', 'operator_id', 'clearing_account_id', 'name', 'phone', 'pay_config', 'pay_method', 'transfer_out_period', 'transfer_remark'],

		list: ["Post", 'clearing-account/list', 'page', 'name', 'operator_id'],
		listByOperator: ["Post", 'clearing-account/list-by-page', 'page', 'name'],

		listAll: ["Post", 'clearing-account/list-all', 'operator_id'],
		listAllByOperator: ["Post", 'clearing-account/list', 'station_operator_id'],

		detail: ["Post", 'clearing-account/detail', 'clearing_account_id'],
		delete: ["Post", 'clearing-account/delete', 'clearing_account_id'],

		// 分账账户 自动审核
		hasAutoConfirm: ["Post", 'clearing-account/has-auto-confirm'],
		setAutoConfirm: ["Post", 'clearing-account/set-auto-confirm', 'id', 'auto_confirm_method'],

		// 分账账户 自动提现
		setAutoTransfer: ["Post", 'clearing-account/set-auto-transfer-out', 'id'],

		// 分账账户 独立电商商户 微信分账
		openWxSettle: ["Post", 'clearing-account/add-receiver-to-ecommerce', 'id'],
		closeWxSettle: ["Post", 'clearing-account/delete-receiver-from-ecommerce', 'id'],

		resetAccount: ["Post", 'clearing-account/reset-account', 'clearing_account_id', 'username'], // 重置分账账号登录用户名密码
		changePassword: ["Post", 'clearing-account/change-password', 'old_password', 'new_password'], // 分账账号登录后 修改密码

		orderAccount: ["Post", 'clearing-account/refund-account', 'account_id', 'operator_id'], // 选择订单扣款账户
		serviceAccount: ["Post", 'operator/service-charge/account/update', 'clearing_account_id', 'operator_id'], // 选择服务费扣款账户
	},
	// 已迁移：module/account.js
	ClearingPayment: {
		// 支付记录
		listByTransferId: ["Post", 'pay/paging', 'page', 'target_id', 'target_type'],
		query: ["Post", 'account-transfer/query', 'id'],

		listByTradeId: ["Post", 'pay/list-pay', 'page', 'clearing_trade_id'],
		listByTradeIdByOperator: ["Post", 'pay/list', 'page', 'clearing_trade_id'],

		orderPay: ["Post", 'pay/order-pay', 'order_sn', 'outer_user_id'],
	},
	// 已迁移：module/account.js
	AccountTransfer: {
		// 转账
		list: ["Post", 'account-transfer/paging', 'page', 'operator_id', 'clearing_account_id', 'confirm_platform', 'status', 'operator_pay_config_id', 'channel', 'transfer_method', 'order_sn', 'begin_money', 'end_money'],
		detail: ["Post", 'account-transfer/detail', 'id'],
		refund: ["Post", 'account-transfer/refund', 'id'],
		stat: ["Post", 'account-transfer/stat', 'begin_time', 'end_time'],

		updatePayConfig: ["Post", 'account-transfer/update-pay-config', 'id', 'pay_config'], // 设置本次转账账户
		platformConfirmPass: ["Post", 'account-transfer/platform-confirm', 'id', 'transfer_method'], // 通过审核 选择打款平台
		batchPlatformConfirm: ["Post", 'account-transfer/batch-platform-confirm', 'ids', 'transfer_method'], // 批量通过审核 选择打款平台
		platformConfirmNoPass: ["Post", 'account-transfer/platform-confirm-no-pass', 'id'], // 不通过审核 选择打款平台
	},
	// 已迁移：module/account.js
	VirtualAccount: {
		// 虚拟账户
		list: ["Post", 'account/list-by-user', 'page', 'page_size', 'user_id', 'type', 'channel'],
		listByAccount: ["Post", 'account/list', 'clearing_account_id', 'operator_pay_config_id'],

		detail: ["Post", 'account/detail', 'id'],

		moneyList: ["Post", 'account-money/paging', 'page', 'account_id', 'subject', 'begin_time', 'end_time'], // 账户金额变动记录

		transfer: ["Post", 'account/transfer-to-account', 'from_account_id', 'to_account_id', 'money'], // 服务费收款账户转账至虚拟微信、支付宝账户
		withdraw: ["Post", 'account/transfer-money', 'id', 'money'], // 账户提现

		/* createOrder: ['charge-order/create-charge-order', 'account_id', 'price', 'pay_method'],  // 账户充值 - 生成订单
		createQrCode: ["Post", 'account/recharge-account', 'order_sn'],  // 账户充值 - 生成支付链接 */
		createOrder: ["Post", 'account/recharge-account', 'account_id', 'price', 'pay_method'], // 账户充值 - 生成支付链接

		createOrderByDevice: ["Post", 'account/device-account-recharge', 'operator_id', 'pay_method', 'uids'], // TODO 根据选择的设备 生成对应的 服务费支付链接
	},
	// 已迁移：module/account.js
	ClearingStatement: {
		stat: ["Post", 'statement/stat'],
		doing: ["Post", 'statement/list/recent', 'type'],

		// 对账单
		list: ["Post", 'statement/list', 'page', 'page_size', 'operator_id', 'begin_time', 'end_time', 'type'],

		export: ["Post", 'statement/add-task', 			  'operator_id', 'type', 'begin_time', 'end_time'],
		exportVip: ["Post", 'statement/add-vip-monthly-task', 'operator_id', 'type', 'begin_time', 'end_time'],

		recent: ["Post", 'statement/list/operator-recent', 'operator_id'],
		recentVip: ["Post", 'statement/list/vip-operator-recent', 'operator_id'],

		deleteTask: ["Post", 'statement/delete-task', 'task_id', "type"],
	},

	// 片区 | 已迁移：module/org-station.js
	Org: {
		save: ["Post", 'org/create', 'org_id', 'name', 'operator_id', 'province', 'city', 'county', 'street', 'region_code', 'address', 'phone', 'tenement', 'tenement_contacts', 'tenement_contacts_phone', 'charge_config_ids', 'clearing_config_id', 'resource_package_config_id', 'recharge_config_id', 'recharge_car_config_id',],
		delete: ["Post", 'org/delete', 'org_id'],
		detail: ["Post", 'org/detail', 'org_id'],

		list: ["Post", 'org/list', 'page', 'operator_id', 'name', 'sort', 'sub_operator_id'],
		listAll: ["Post", 'org/list-all', 'operator_id', 'status'],
		listName: ["Post", 'org/list-name', 'operator_id', 'status'],
		listByName: ["Post", 'org/list', 'page_size', 'name', 'operator_id'],

		recycleList: ["Post", 'org/recover-org-list', 'page', 'status', 'operator_id', 'name'], // 回收片区列表
		recycle: ["Post", 'org/recover-org', 'status', 'org_ids'], // status: -400:放入回收站;
		batchDelete: ["Post", 'org/batch-delete', 'org_ids'], // 批量删除

		changeOperator: ["Post", 'org/update-org-operator', 'org_id', 'operator_id'], // 更改运营商

		getChargeConfig: ["Post", 'org/get-org-charge-config', 'id'], // 获取片区计费模版列表
		setChargeConfig: ["Post", 'org/set-org-charge-config', 'id', 'charge_config_id'], // 设置片区计费模版列表
		setMultiChargeConfig: ["Post", 'org/set-org-multi-charge-config', 'org_id', 'charge_config_id_list'], // 设置片区多个计费模版
		updateChargeConfig: ["Post", 'org/update-org-charge-config', 'id', 'target_charge_config_id', 'row_charge_config_id'], // 更新片区计费模版列表

		setPreChargeChargeConfig: ["Post", 'org/set-pre-charge-charge-config', 'org_id', 'operator_config_id', 'flag_pre_charge', 'pre_charge_reserve_time', 'flag_pre_charge_charge', 'pre_charge_config_id'], // 开启预约充电

		getAllCardCount: ["Post", 'org/org-all-card-count', 'org_id'], // 获取片区卡片数量
		
		getUnbindByRechargeConfig: ["Post", 'org/list-unbind-by-recharge-clearing-config', 'page', 'recharge_config_id', 'org_name'], // 获取未绑定该充值模版的片区
		getUnbindByChargeConfig: ["Post", 'org/list-unbind-by-charge-config', 'page', 'charge_config_id', 'org_name'], // 获取未绑定该计费模版的片区
        
		getOpenFlagMemberPriceCount: ["Post", 'org/get-open-station-flag-member-price-count', 'org_id'], // 获取片区站点开启 flag_member_price 的个数
        closeStationFlagMemberPrice: ["Post", 'org/close-station-flag-member-price', 'org_id'], // 关闭站点 flag_member_price
	},
	// 片区有序充电 | 已迁移：module/org-station.js
	OrgPowerDirect: {
		save: ["Post", 'org-power-direct/save', 'id', 'org_id', 'config'],
		detail: ["Post", 'org-power-direct/detail', 'org_id'],
		poolSet: ["Post", 'org-power-direct/pool-set', 'org_id'],
		poolGet: ["Post", 'org-power-direct/pool-get', 'org_id'],

		list: ["Post", 'org-power-direct/list', 'name', 'org_id', 'operator_id', 'page'],

		powerDirectLogList: ["Post", 'org-power-direct/power-direct-log-list', 'org_id', 'begin_time', 'end_time', 'page', 'page_size'],  // 调度日志

		setChargeConfig: ["Post", 'org-power-direct/set-charge-config', 'org_id', 'flag_independent_charge', 'charge_config_id'],  // 设置计费模板

		poolNodeSet: ["Post", 'org-power-direct/pool-node-set', 'org_id', 'suid', 'max_power', 'min_power', 'max_step_power'],  // 设置节点参数
		getSensorData: ["Post", 'org-power-direct/get-sensor-data', 'device_id'],  // 获取采集器电气数据
	},
	// 充电站 | 已迁移：module/org-station.js
	Station: {
		list: ["Post", 'station/list', 'page', 'operator_id', 'org_id', 'station_id', 'name', 'sort', 'gateway_id', 'is_off', 'device_type', 'type', 'flag_auto_close', 'flag_parking_discount'],
		// listByOrgId: ['station/list-by-orgId', 'page', 'org_id', 'sort'], // 片区的充电站列表
		listByOrgId: ["Post", 'station/list', 'page', 'org_id'], // 片区的充电站列表
		listAll: ["Post", 'station/all-list', 'operator_id'], // 选择用充电站列表
		listAllSimple: ["Post", 'station/all-list-simple'],
		listByName: ["Post", 'station/list', 'page_size', 'name', 'operator_id'],

		// 创建、编辑充电站
		create: ["Post", 'station/create', 			 'id', 'operator_id', 'name', 'province', 'city', 'county', 'address', 'longitude', 'latitude', 'type', 'device_type', 'gateway_id', 'org_id'],
		createByOperator: ["Post", 'station/create-by-operator', 'id', 'operator_id', 'name', 'province', 'city', 'county', 'address', 'longitude', 'latitude', 'type', 'device_type', 'gateway_id', 'org_id'],
		update: ["Post", 'station/update', 		     'id', 'operator_id', 'name', 'province', 'city', 'county', 'address', 'longitude', 'latitude', 'type', 'device_type', 'gateway_id', 'org_id', 'charge_config_id', 'clearing_config_id'],

		// 离线充电站列表
		offList: ["Post", 'station/off-list', 'operator_id', 'name', 'page'],
		// 待审核充电站列表
		checkList: ["Post", 'station/check-list', 'operator_id', 'name', 'page'],
		check: ["Post", 'station/check', 'station_id', 'status'], // 审核充电站
		// 回收充电站列表
		recycleList: ["Post", 'station/recover-station-list', 'page', 'status', 'operator_id', 'org_ids', 'name'], // 回收充电站列表
		recycle: ["Post", 'station/recover-station', 'status', 'ids'], // status: -400:放入回收站;200:移出回收站;

		detail: ["Post", 'station/detail', 'station_id'], // 充电站详情
		allot: ["Post", 'station/allot', 'station_ids', 'operator_id', 'org_id'], // 更改片区所属
		delete: ["Post", 'station/delete', 'id', 'station_id'], // id-管理端传ID station_id-运营端传ID => 传两次充电站ID
		batchDelete: ["Post", 'station/batch-delete', 'station_ids'], // 批量删除

		setQuantifiable: ["Post", 'station/set-station-auto-close', 'station_id'], // 设置充电站是否有定时/定量模式
		batchSetQuantifiable: ["Post", 'station/batch-set-station-auto-close', 'station_ids'], // 批量设置充电站是否有定时/定量模式
		checkGatewayId: ["Post", 'station/check-by-gatewayId', 'gateway_id'],
		checkGatewayByAdmin: ["Post", 'station/check-gateway', 'gateway_id'],
		setChargeConfigDecimal: ["Post", 'station/set-station-service-fee-charge-config-decimal', 'station_id'], // 设置充电站是否开启 汽车充新计费模式

		setGaode: ["Post", 'station/set-station-gd', 'station_id'], // 设置站点是否开启高德推送
		setHaluo: ["Post", 'station/set-station-halo', 'station_id'], // 设置站点是否开启哈啰推送
		batchSetHaluo: ["Post", 'station/batch-set-station-halo', 'operator_id', 'org_id', 'flag'], // 批量设置站点是否开启哈啰推送

        parkingStart: ["Post", 'station/set-station-discount-parking', 'station_id'], // 开启停车减免
        parkingConfig: ["Post", 'station/set-station-discount-parking-config', 'station_id', 'config'], // 停车减免配置

		getUnbindByChargeConfig: ["Post", 'station/list-unbind-by-charge-config', 'page', 'charge_config_id', 'station_name'], // 获取未绑定该计费模版的站点
	
		exportList: ["Post", 'export-task/list', 'page', 'type', 'status'], // 导出任务列表
        export: ["Post", 'export-task/create-station-export', 'operator_id', 'org_id', 'station_id'],
		setMultiChargeConfig: ["Post", 'station/set-station-multi-charge-config', 'station_id', 'charge_config_id_list'], // 设置站点多个计费模版
		getChargeConfig: ["Post", 'station/get-station-charge-config', 'id'], // 获取站点计费模板列表
    },

	// 设备 | 已迁移：module/device.js
	Device: {
		// 设备
		list: ["Post", 'device/list',		   'page', 'user_id',     'org_id', 'station_id', 'uid', 'suid', 'gateway_id', 'is_off', 'types', 'sort', 'pre_status', 'flag_alipay_shualan', 'flag_service_fee_support'],
		listByOperator: ["Post", 'device/list-params', 'page', 'operator_id', 'org_id', 'station_id', 'uid', 'suid', 'gateway_id', 'is_off', 'types', 'sort', 'pre_status', 'flag_alipay_shualan', 'flag_service_fee_support'],
		offList: ["Post", 'stat-new/device-offline-list'],
		
		shuaLanlist: ["Post", 'device/shualan-device-list', 'uid', 'suid', 'org_id', 'user_id', 'station_id', 'gateway_id', 'page', 'types', 'flag_alipay_shualan'],  // 刷蓝设备列表

		save: ["Post", 'device/save', 'suid', 'node_index', 'station_id'],

		detail: ["Post", 'device/detail', 'suid'], // 运营商端 设备详情
		detailBySuid: ["Post", 'device/detail-by-suid', 'suid'], // 管理端 设备详情

		delete: ["Post", 'device/delete', 'uid', 'node_index', 'station_id'],
		buildNetwork: ["Post", 'device/build-network', 'station_id', 'channel'], // 组网
		checkServiceFee: ["Post", 'device-account/device-service-fee-balance', 'device_uid'], // TODO 校验设备是否还有服务费未收取
		checkServiceFeeById: ["Post", 'device-account/service-fee-unpaid-info', 'station_id', 'org_id'], // TODO 校验站点/片区是否还有设备服务费未收取

		portList: ["Post", 'device/port-list', 'device_id'], // 设备的插口列表

		createPowerQrcode: ["Post", 'device/create-power-qrcode', 'uid'], // 设备二维码 - 需手动拼接
		iotState: ["Post", 'device/get-iot-state', 'suid'], // 获取设备状态

		mark: ["Post", 'device/mark-device', 'device_id', 'port_index', 'mark'], // 设置备注

		getCabinetPwd: ["Post", 'device/get-cabinet-pwd', 'suid'], // 获取换电柜设备密码
		setCabinetPwd: ["Post", 'device/set-cabinet-pwd', 'uid', 'pwd'], // 设置换电柜设备密码

		openTest: ["Post", 'device/open-test' /* 'suid', 'port_index' */],
		closeTest: ["Post", 'device/close-test' /* 'suid', 'port_index' */],
		gateTest: ["Post", 'device/test-gate-control' /* 'suid', 'port_index' 'gate_state'*/],

		updateGateway: ["Post", 'device/update-gateway-device-status'],

		setAlipayShualan: ["Post", 'device/set-alipay-shualan', 'device_id', 'flag_alipay_shualan'],
		batchSetAlipayShualan: ["Post", 'device/batch-set-alipay-shualan', 'device_ids', 'flag_alipay_shualan'],
		alipayDeviceQrcode: ["Post", 'device/alipay-device-qr-code', 'url', 'query_param', 'describe'],

		getDcConfig: ["Post", 'device/get-dc-config'],  // 获取直流桩配置

		statOrderByDevice: ["Post", 'device/stat-order-by-device', 'suid', 'degin_time', 'end_time'], // 根据设备统计订单交易额/订单数
		setCoinCount: ["Post", 'device/set-coin-count', 'suid', 'coin_count'], // 设置可投币十路机投币数量

		exportList: ["Post", 'export-task/list', 'page', 'type', 'status'], // 导出任务列表
		export: ["Post", 'export-task/create-device-export', 'operator_id', 'org_id', 'station_id', 'online_status', 'types'],


		sendDeviceQrcodeZip: ["Post", 'device/send-device-qrcode-zip', 'uid', 'qrcode_type'],   // 按设备uid生成设备与端口二维码并邮件发送压缩包
		
		setFlagVinCharge: ["Post", 'device/set-flag-vin-charge', 'id', 'is_enable'], // 设置是否开启vin充电
	},
	// 设备参数的设置与获取 | 已迁移：module/device.js
	DeviceConfig: {
		// 获取 单个设备数据
		getConfig: ["Post", 'station/get-node-system-config', 'gateway_uid', 'node_index'],
		// 设置 单个设备数据
		setConfig: ["Post", 'station/set-node-system-config', 'gateway_uid', 'node_index', 'charge_full_timeout', 'no_load_timeout', 'charge_full_power_threshold', 'no_load_power_threshold', 'max_charge_time', 'height_temperature_threshold', 'cabinet_heater_enable ', 'max_charge_power', 'charge_single_amount', 'max_current'],
		// 批量设置 设备数据
		batchSetConfig: ["Post", 'station/batch-update-set-node-system-config', 'json', 'charge_full_timeout', 'no_load_timeout', 'charge_full_power_threshold', 'no_load_power_threshold', 'max_charge_time', 'height_temperature_threshold', 'cabinet_heater_enable ', 'max_current'],

		// 获取 10、12路机 插口最大功率设置
		getMultiholePower: ["Post", 'station/get-node-system-config-12', 'json'],
		// 设置 10、12路机 设备数据
		setMultiholeConfig: ["Post", 'station/set-node-system-config', 'gateway_uid', 'node_index', 'charge_full_timeout', 'no_load_timeout', 'charge_full_power_threshold', 'no_load_power_threshold', 'max_charge_time', 'height_temperature_threshold', 'charge_single_amount',],
		// 设置 10、12路机 插口最大功率
		setMultiholePower: ["Post", 'station/set-node-system-config-12', 'json'],
	},
	// 设备参数设置任务 | 已迁移：module/device.js
	DeviceTask: {
		save: ["Post", 'device-task/save', 'id', 'operator_id', 'name', 'config', 'type'],
		list: ["Post", 'device-task/list', 'page', 'operator_id', 'name', 'config_type'],
		delete: ["Post", 'device-task/delete', 'id'],
		detail: ["Post", 'device-task/detail', 'id'],
		execute: ["Post", 'device-task/execute', 'id'],
	},
	// 设备参数设置任务 | 已迁移：module/device.js
	DeviceTaskMember: {
		list: ["Post", 'device-task-member/list', 'page', 'task_id', 'device_type', 'status'],

		save: ["Post", 'device-task-member/save', 'task_id', 'device_id'],
		batchSave: ["Post", 'device-task-member/batch-save', 'task_id', 'device_ids'],
		saveByStation: ["Post", 'device-task-member/save-by-station', 'task_id', 'station_id'],
		batchSaveByStation: ["Post", 'device-task-member/batch-save-by-station', 'task_id', 'station_ids'],

		delete: ["Post", 'device-task-member/delete', 'id'],
		batchDelete: ["Post", 'device-task-member/batch-delete', 'ids'],
	},

	// 设备型号管理 | 已迁移：module/device.js
	DeviceModel: {
		list: ["Post", 'device-model/list',  'code', 'type', 'uid_rule', 'name', 'status', 'page', 'page_size'],  
		save: ["Post", 'device-model/save', 'id', 'code', 'type', 'name', 'uid_rule', 'port_count', 'config', 'status'],

		updateStatus: ["Post", 'device-model/update-status', 'id', 'status'],  // 更新状态
		batchUpdateStatus: ["Post", 'device-model/batch-update-status', 'ids', 'status'],  // 批量更新状态
	},

	// 
	// 已迁移：module/device.js
	RedisWorker: {
		createTask: ["Post", 'redis-worker/create-task', 'function', 'params'],
		findTask: ["Post", 'redis-worker/find-task', 'task_id'],
	},

	// 换电柜电池 | 已迁移：module/device.js
	Battery: {
		create: ["Post", 'battery/create', 'pack_id', 'operator_id'],
		list: ["Post", 'battery/list', 'page', 'operator_id', 'pack_id'],
		detail: ["Post", 'battery/detail', 'id'],
		import: ["Post", 'battery/import', 'file'],
		delete: ["Post", 'battery/delete', 'id'],

		bind: ["Post", 'battery/bind', 'pack_ids', 'operator_id'],
	},
	// 道闸 | 已迁移：module/device.js
	Gate: {
		save: ["Post", 'gate/save', 'operator_id', 'org_id', 'suid', 'node_index', 'remark'],
		list: ["Post", 'gate/list', 'page', 'operator_id', 'org_id', 'uid', 'suid', 'type'],
		detail: ["Post", 'gate/detail', 'id'],
		detailBySuid: ["Post", 'gate/detail-by-suid', 'suid'],
		delete: ["Post", 'gate/delete', 'id'],

		remark: ["Post", 'gate/gate-remark', 'id', 'remark'],

		action: ["Post", 'gate/test-gate-control', 'suid', 'port_index', 'gate_state'], // 开关闸
		actionList: ["Post", 'gate/action-log', 'page', 'type', 'node_index', 'status', 'phone'], // 开关闸记录
	},
	// 摄像头 | 已迁移：module/device.js
	Camera: {
		list: ["Post", 'camera/list', 'page', 'operator_id', 'org_id', 'station_id', 'camera_index_code'],
		import: ["Post", 'camera/batch-save', 'operator_id', 'org_id', 'station_id', "cameras"],
		detail: ["Post", 'camera/detail', 'id'],
		// delete: ['camera/delete', 'id'],
		delete: ["Post", 'camera/batch-delete', 'ids'],

		getUrls: ["Post", 'hik-camera/camera', 'camera_index_code'], // 获取监控预览地址
	},
	// 海康摄像设置 | 已迁移：module/device.js
	HikConfig: {
		save: ["Post", 'hik-config/save', 'id', 'operator_id', 'host', 'app_key', 'app_secret'],
		list: ["Post", 'hik-config/list', 'page', 'page_size', 'operator_id'],
		delete: ["Post", 'hik-config/delete', 'id'],

		deviceList: ["Post", 'hik-camera/camera-list', 'page', 'page_size', 'hik_config_id'], // 通过配置 搜索海康那边的设备
	},

	// 充电订单 | 已迁移：module/order.js
	Order: {
		list: ["Post", 'order/list', 'type', 'page', 'sn', 'outer_sn', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'operator_id', 'org_id', 'station_id', 'device_type', 'status', 'pay_method', 'clearing_status', 'finish_code', 'power_mode', 'begin_time', 'end_time', 'clearing_begin_time', 'clearing_end_time', 'finish_begin_time', 'finish_end_time', 'license_plate_number', 'flag_booking', 'vin', 'user_id', 'refund_begin_time', 'refund_end_time'],
		precontractList: ["Post", 'order/pre-order-list', 'type', 'page', 'sn', 'outer_sn', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'operator_id', 'org_id', 'station_id', 'device_type', 'status', 'pay_method', 'clearing_status', 'finish_code', 'power_mode', 'begin_time', 'end_time', 'clearing_begin_time', 'clearing_end_time', 'finish_begin_time', 'finish_end_time', 'license_plate_number', 'flag_booking', 'vin', 'user_id'],
		historyList: ["Post", 'order/history-order-list', 'type', 'page', 'sn', 'outer_sn', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'operator_id', 'org_id', 'station_id', 'device_type', 'status', 'pay_method', 'clearing_status', 'finish_code', 'power_mode', 'begin_time', 'end_time', 'clearing_begin_time', 'clearing_end_time', 'finish_begin_time', 'finish_end_time', 'license_plate_number', 'flag_booking', 'vin', 'user_id', 'refund_begin_time', 'refund_end_time'],
		pursueList: ["Post", 'pursue-order/power-order-list', 'page', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'begin_time', 'end_time', 'operator_id', 'org_id', 'station_id', 'device_type', 'power_outer_sn', 'power_order_sn'],
        detail: ["Post", 'order/detail', 'order_id'],
		getDetailByChargeTransactionId: ["Post", 'order/getByChargeTransactionId', 'charge_transaction_id'],  // 通过charge_transaction_id获取订单详情

		refund: ["Post", 'order/refund', 'order_sn'],
		refundAfterClearing: ["Post", 'order/refund-after-clearing', 'order_sn', 'clearing_config_id', 'money', 'time'],
		refundHaLuo: ["Post", 'order/hello-order-refund', 'order_sn', 'clearing_config_id', 'refund_money'], // 哈啰退款-clearing_config_id 仅用于调整传参位置
		refundCustom: ["Post", 'order/refund-custom-money', 'order_sn', 'money'], // 汽车充订单 正常流程退款失败的应对手段 ==> 特殊订单(如工商行订单)的退款

		payScoreCancel: ["Post", 'order/cancel-payscore-order', 'id'],
		compelFinish: ["Post", 'order/update-order-status', 'order_id'],
		finishOverTime: ["Post", 'order/test-time-over', 'order_id'],

		getActionList: ["Post", 'action/list-by-order-id', 'target_id'], // 获取开关日志
		getPowerRecord: ["Post", 'device-power-record/list', 	    'order_id', 'page'], // 订单功率变化曲线图
		getPowerRecordV2: ["Post", 'device-power-record/power-log', 'order_id', 'page'], // 订单功率变化曲线图
		// forceOrderClose: ['order/force-order-status', 'order_id'],
		getLastPowerLog: ["Post", 'device-power-record/get-last-power-log', 'order_id', 'page'],

		manualClearing: ["Post", 'order/manual-clearing-order', 'order_id', 'order_type'], // 手动结算
		batchManualClearing: ["Post", 'order/manual-clearing-order/batch', 'order_ids', 'order_type'], // 批量手动结算

		exportList: ["Post", 'export-task/list', 'page', 'type', 'status'], // 导出任务列表

		getLabel: ["Post", 'ml-order-pred/detail', 'order_id'],
		setLabel: ["Post", 'ml-order-pred/save', 'id', 'order_id', 'order_report', 'label'],

		closePreOrder: ["Post", 'order/close-pre-order', 'sn'], // 取消预约订单
		preOrderRefund: ["Post", 'order/pre-order-refund', 'order_sn', 'clearing_config_id', 'money'],

		// 充电订单获取占位订单详情
		occupyDetailByChargeOrderId: ["Post", 'occupy-order/detail-by-charge-order-id', 'order_id'],
	},
	// 充值订单 | 已迁移：module/order.js
	RechargeOrder: {
		list: ["Post", 'charge-order/list', 'type', 'page', 'operator_id', 'org_id', 'order_sn', 'outer_sn', 'user_name', 'user_phone', 'clearing_status', 'charge_type', 'status', 'pay_method', 'card_uid', 'begin_time', 'end_time', 'refund_begin_time', 'refund_end_time'],
		listByCard: ["Post", 'charge-order/list', 'type', 'page', 'pay_method', 'card_uid', 'begin_time', 'end_time'],
		detail: ["Post", 'charge-order/detail', 'id'],
		detailByPaySn: ["Post", 'charge-order/detail-sn', 'pay_sn'],
		refundAfterClearing: ["Post", 'charge-order/charge-order-refund', 'sn', 'clearing_config_id', 'money', 'ticket_id'],
		// refundCustom: ['charge-order/charge-order-refund-money', 'order_sn', 'money'], // 汽车充订单 正常流程退款失败的应对手段 ==> 特殊订单(如工商行订单)的退款
		refundCustom: ["Post", 'charge-order/charge-order-refund', 'order_sn', 'money'],

		manualClearing: ["Post", 'charge-order/manual-clearing-order', 'order_id', 'order_type'], // 手动结算

		exportList: ["Post", 'export-task/list', 'page', 'type', 'status'], // 导出任务列表
	},
	// 占用费订单 | 已迁移：module/order.js
	OccupyOrder: {
		list: ["Post", 'occupy-order/list', 'type', 'page', 'sn', 'outer_sn', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'operator_id', 'org_id', 'station_id', 'status', 'pay_method', 'clearing_status', 'finish_code', 'begin_time', 'end_time', 'create_begin_time', 'create_end_time', 'clearing_begin_time', 'clearing_end_time', 'user_id',],
		detail: ["Post", 'occupy-order/detail', 'id'],
		refundAfterClearing: ["Post", 'occupy-order/refund-after-clearing', 'occupy_order_sn', 'clearing_config_id', 'money'],
		refundGateAfterClearing: ["Post", 'occupy-order/refund-gate-order-after-clearing', 'occupy_order_sn', 'clearing_config_id', 'money'],

		manualClearing: ["Post", 'occupy-order/manual-clearing-order', 'order_id', 'order_type'], // 手动结算

		queryOrderByDevice: ["Post", 'occupy-order/query-order-by-device', 'suid', 'port_index'], // 获取端口的占用订单信息
	},
	// 欠款订单 | 已迁移：module/order.js
	PursueOrder: {
		list: ["Post", 'pursue-order/list', 'type', 'page', 'sn', 'outer_sn', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'operator_id', 'org_id', 'status', 'pay_method', 'clearing_status', 'begin_time', 'end_time', 'clearing_begin_time', 'clearing_end_time', 'user_id', 'occupy_order_sn',],
		detail: ["Post", 'pursue-order/detail', 'id'],
		refundAfterClearing: ["Post", 'pursue-order/refund-after-clearing', 'order_sn', 'clearing_config_id', 'money'],

		manualClearing: ["Post", 'pursue-order/manual-clearing-order', 'order_id', 'order_type'], // 手动结算

		batchManualClearing: ["Post", 'pursue-order/batch-manual-clearing-order', 'order_ids', 'order_type'], // 批量结算

		powerOccupyOrderList: ["Post", 'pursue-order/power-occupy-order-list', 'socket_uid', 'gateway_uid', 'nickname', 'user_phone', 'begin_time', 'end_time', 'clearing_begin_time', 'clearing_end_time', 'user_id', 'sn', 'page', 'type','pay_method', 'status', 'clearing_status', 'operator_id', 'org_id', 'outer_sn', 'occupy_order_sn', 'refund_status',],
	},
	// 换电柜订单 | 已迁移：module/order.js
	CabinetOrder: {
		list: ["Post", 'exchange-order/list', 'type', 'page', 'sn', 'phone', 'operator_id', 'status', 'begin_time', 'end_time'],
		detail: ["Post", 'exchange-order/detail', 'sn'],

		manualClearing: ["Post", 'exchange-order/manual-clearing-order', 'order_id', 'order_type'], // 手动结算
	},
	// 换电套餐 | 已迁移：module/order.js
	CabinetPackage: {
		list: ["Post", 'exchange-package/list', 'page', 'phone', 'operator_id', 'status'],
		detail: ["Post", 'exchange-package/detail', 'id'],

		logList: ["Post", 'user-exchange-record/list', 'page', 'operator_id', 'exchange_package_id', 'begin_time', 'end_time'],
		logDetail: ["Post", 'user-exchange-record/detail-by-uid', 'uid'],
		updateStatus: ["Post", 'user-exchange-record/update-status', 'id', 'status'],
	},
	// 结算订单 | 已迁移：module/order.js
	ClearingOrder: {
		list: ["Post", 'clearing-order/list', 'page', 'operator_id', 'status', 'target_type', 'target_clearing_time_begin', 'target_clearing_time_end', 'create_time_begin', 'create_time_end'],
	},
	// 金额变动记录 | 已迁移：module/order.js
	MoneyHistory: {
		list: ["Post", 'pay/paging', 'page', 'target_id', 'target_type'],
		listByPower: ["Post", 'pay/list-by-power', 'target_id'],
	},
	// 退款申请 | 已迁移：module/feedback.js
	Refund: {
		list: ["Post", 'refund-record/list', 'page', 'id_name', 'bank_card_id', 'operator_id', 'user_id', 'status', 'target_type', 'begin_time', 'end_time'],
		audit: ["Post", 'refund-record/audit', 'id', 'status', 'money', 'fail_reason'],
		detail: ["Post", 'refund-record/detail', 'id'],

		update: ["Post", 'refund-record/query-transfer-result', 'id'],
	},

	// 结算打款 - 已废弃 | 已迁移：module/order.js
	ClearingTrade: {
		list: ["Post", 'clearing-trade/list', 'page', 'operator_id', 'status', 'target_pay_time_begin', 'target_pay_time_end'],
		detail: ["Post", 'clearing-trade/detail', 'clearing_trade_id'],
		check: ["Post", 'clearing-trade/check', 'clearing_trade_id'],
		waitList: ["Post", 'clearing-trade/wait-list', 'target_pay_time_begin', 'target_pay_time_end', 'page'],
		updateTradeAccountPayConfig: ["Post", 'clearing-trade/update-trade-account-pay-config', 'id', 'alipay_account_id', 'alipay_real_name'],
	},
	// 结算明细 - 已废弃 | 已迁移：module/order.js
	ClearingTradeItem: {
		list: ["Post", 'clearing-trade-item/list', 'operator_id', 'target_pay_time_begin', 'target_pay_time_end', 'create_time_begin', 'create_time_end', 'status', 'subject', 'page'],
		listByOrderId: ["Post", 'clearing-trade-item/list-by-order-id', 'order_id', 'type'],
		listByClearingTradeId: ["Post", 'clearing-trade-item/list-by-clearing-trade-id', 'clearing_trade_id', 'page'],

		getSubRecord: ["Post", 'clearing-order/sub-order/list', 'order_id', 'order_type'],
	},

	// 车辆信息 | 已迁移：module/device.js
	Car: {
		list: ["Post", 'car/list', 'page', 'license_plate_number', 'vin', 'phone']
	},

	// 实体卡 | 已迁移：module/card.js
	Card: {
		list: ["Post", 'card/query', 'page', 'uid', 'operator_id', 'org_id', 'type', 'user_phone', 'create_time_start', 'create_time_end', 'update_time_start', 'update_time_end', 'activate_time_start', 'activate_time_end', 'status', 'flag_delete'],
		update: ["Post", 'card/update', 'uid', 'org_id', 'operator_id'],
		batchUpdate: ["Post", 'card/batch-update-org', 'uids', 'org_id', 'operator_id', 'remark'],

		import: ["Post", 'card/import-card-list', 'file'], // 导入卡 文件导入
		export: ["Post", 'card/export', 'operator_id', 'org_id', 'uid', 'status', 'create_time_start', 'create_time_end', 'update_time_start', 'update_time_end', 'page'], // 导出卡

		detail: ["Post", 'card/detail', 'uid'],
		detailById: ["Post", 'card/detail-by-id', 'id'],

		// 卡操作
		delete: ["Post", 'card/delete', 'uid'],
		loss: ["Post", 'card/lossCard', 'uid'],
		findBack: ["Post", 'card/findBack', 'uid'],
		unbind: ["Post", 'card/unbind', 'uid'],
		reset: ["Post", 'card/reset', 'uid'],
		discard: ["Post", 'card/discard', 'uid'], // 卡废弃
		remark: ["Post", 'card/update-remark', 'uid', 'remark'],

		// 卡详情-列表
		orderList: ["Post", 'card/order-list', 'uid', 'page'],
		moneyList: ["Post", 'card/money-list', 'uid', 'page'],
		logList: ["Post", 'card/log-list', 'uid', 'page'],
		errorList: ["Post", 'card/error-log-list', 'card_uid', 'page'],

		synchronization: ["Post", 'card/synchronization', 'uid'],

		// 充值
		recharge_money: ["Post", 'card/recharge', 'uid', 'money'],
		recharge_time: ["Post", 'card/recharge', 'uid', 'resource_package_config_id', 'data'],

		// 扣减
		abatement_money: ["Post", 'card/deduct', 'uid', 'money'],
		abatement_time: ["Post", 'card/deduct', 'uid', 'day', 'time', 'package_id'],
	},
	// 虚拟卡 | 已迁移：module/card.js
	VirtualCard: {
		list: ["Post", 'virtual-card/list', 'page', 'uid', 'operator_id', 'org_id', 'type', 'user_phone', 'status', 'create_time_start', 'create_time_end', 'flag_delete'],
		update: ["Post", 'virtual-card/update-org', 'uid', 'org_id', 'operator_id'],
		batchUpdate: ["Post", 'virtual-card/batch-update-org', 'uids', 'org_id', 'operator_id'],

		delete: ["Post", 'virtual-card/delete', 'uid'],
		detail: ["Post", 'virtual-card/detail', 'uid'],
		detailById: ["Post", 'virtual-card/detail-by-id', 'id'],
		detailByDelete: ["Post", 'virtual-card/detail-by-delete', 'uid'],

		create: ["Post", 'virtual-card/create', 'phone', 'org_id', 'type'],
		discard: ["Post", 'virtual-card/discard', 'uid'], // 卡废弃

		export: ["Post", 'virtual-card/export', 'operator_id', 'org_id', 'uid', 'node_type', 'create_time_start', 'create_time_end', 'page'], // 导出卡 文件导入

		orderList: ["Post", 'virtual-card/order-list', 'uid', 'page'],
		vinOrderList: ["Post", 'virtual-card/vin-order-list', 'uid', 'page'],
		moneyList: ["Post", 'virtual-card/money-list', 'uid', 'page'],
		logList: ["Post", 'virtual-card/log-list', 'id', 'page'],

		// 充值
		recharge_money: ["Post", 'virtual-card/recharge', 'uid', 'money'],
		recharge_time: ["Post", 'virtual-card/recharge', 'uid', 'resource_package_config_id', 'data'],

		// 扣减
		abatement_money: ["Post", 'virtual-card/deduct', 'uid', 'money'],
		abatement_time: ["Post", 'virtual-card/deduct', 'uid', 'day', 'time', 'package_id'],
	},
	// 卡片(后台)充值记录 | 已迁移：module/card.js
	CardRechage: {
		realityList: ["Post", 'card/money-list', 'page', 'uid', 'subject', 'begin_time', 'end_time'],
		virtualList: ["Post", 'virtual-card/money-list', 'page', 'uid', 'subject', 'begin_time', 'end_time'],

		/* realityList: ['card/card-info', 'page', 'begin_time', 'end_time'],
		virtualList: ["Post", 'virtual-card/virtual-card-info', 'page', 'begin_time', 'end_time'], */

		save: ["Post", 'recharge-task/save', 'id', 'name', 'card_type', 'type', 'recharge_type', 'money', 'data', 'begin_time', 'end_time'],
		list: ["Post", 'recharge-task/list', 'page', 'operator_id', 'name', 'type', 'card_type'],
		detail: ["Post", 'recharge-task/detail', 'id'],
		execute: ["Post", 'recharge-task/execute', 'id'],

		taskMemberAdd: ["Post", 'recharge-task-member/batch-create', 'task_id', 'card_ids'],
		taskMemberList: ["Post", 'recharge-task-member/list', 'task_id', 'page', 'card_uid', 'card_id'],
		taskMemberRemove: ["Post", 'recharge-task-member/delete', 'task_id', 'id'],

		realityTaskList: ["Post", 'card/list-by-recharge-task', 'page', 'page_size', 'task_id', 'org_id', 'card_uid'],
		virtualTaskList: ["Post", 'virtual-card/list-by-recharge-task', 'page', 'page_size', 'task_id', 'org_id', 'card_uid'],
	},

	// 统计报表 | 已迁移：module/stat.js
	Statement: {
		orgByDay: ["Post", 'stat-day-income/get-org-income', 'page', 'org_name', 'begin_time', 'end_time'],
	},

	// 监控告警 | 已迁移：module/message.js
	Alarm: {
		list: ["Post", 'alarm/list', 'page', 'operator_id', 'source_type', 'station_type_and_subject_list', 'status', 'device_uid', 'flag_read', 'begin_time', 'end_time'],
		create: ["Post", 'alarm/save', 'source_id', 'source_type', 'subject', 'content', 'data'],
		detail: ["Post", 'alarm/detail', 'id'],
		eventList: ["Post", 'alarm/event-list', 'page', 'page_size', 'id'],
	},
	// 系统公告 | 已迁移：module/message.js
	SystemNotice: {
		list: ["Post", 'system-notice/list', 'page', 'type'],
		create: ["Post", 'system-notice/save', 'id', 'type', 'title', 'content'],
		detail: ["Post", 'system-notice/detail', 'id'],
		delete: ["Post", 'system-notice/delete', 'id'],
	},
	// 常见问题 | 已迁移：module/message.js
	CommonQuestion: {
		list: ["Post", 'common-problem/list', 'page', 'type'],
		add: ["Post", 'common-problem/add', 'problem', 'answer', 'type'],
		edit: ["Post", 'common-problem/update', 'problem', 'answer', 'type', 'id'],
		delete: ["Post", 'common-problem/delete', 'id'],
	},

	// 工人管理 - 已废弃 | 已迁移：module/common.js
	Worker: {
		list: ["Post", 'worker/list', 'username', 'page'],
		save: ["Post", 'worker/save', 'username', 'password', 'content'],
		delete: ["Post", 'worker/delete', 'id'],
	},

	// 服务费 | 已迁移：module/service-charge.js
	ServiceCharge: {
		exportList: ["Post", 'export-task/list', 'page', 'type'], // 导出任务列表
	},
	// 服务费 统计 | 已迁移：module/service-charge.js
	ServiceChargeStat: {
		summary: ["Post", 'device-account-money/service-fee-summary-detail', 'operator_id', 'org_id', 'device_uid'],
		summaryOld: ["Post", 'service-fee-order/service-fee-detail', 'operator_id'],

		operatorList: ["Post", 'device-account-money/service-fee-operator-summary-detail-list', 'page', 'order', 'operator_id'],
		orgList: ["Post", 'device-account-money/service-fee-org-summary-detail-list', 'page', 'order', 'operator_id', 'org_id'],
		deviceList: ["Post", 'device-account-money/service-fee-device-summary-detail-list', 'page', 'order', 'operator_id', 'org_id', 'device_uid'],
		deviceByStation: ["Post", 'device-account-money/station-device-account-detail-list', 'page', 'station_id', 'device_uid', 'search_device_uid'],
	},
	// 服务费 账单 | 已迁移：module/service-charge.js
	ServiceChargeBill: {
		billList: ["Post", 'service-fee-order/stat-service-fee-order', 'page', 'operator_id', 'time'], // 旧

		operatorList: ["Post", 'device-account-money/service-fee-operator-bill-list', 'page', 'time', 'operator_id'], // TODO
		orgList: ["Post", 'device-account-money/service-fee-org-bill-list', 'page', 'time', 'operator_id', 'org_id'], // TODO
		deviceList: ["Post", 'device-account-money/service-fee-device-bill-list', 'page', 'time', 'operator_id', 'org_id', 'device_uid'], // TODO
	},
	// 服务费 收费模版 | 已迁移：module/service-charge.js
	ServiceChargeTemp: {
		list: ["Post", 'service-fee-package/list', 'page', 'name', 'payment_mode'],
		save: ["Post", 'service-fee-package/save', 'id', 'name', 'payment_mode', 'config'],
		detail: ["Post", 'service-fee-package/detail', 'id'],
		delete: ["Post", 'service-fee-package/delete', 'id'],
	},
	// 服务费 收费分组 | 已迁移：module/service-charge.js
	ServiceChargeGroup: {
		list: ["Post", 'service-fee-device-group/list', 'page', 'name', 'package_id', 'operator_id', 'flag_charge', 'flag_service_rate', 'sort'],
		save: ["Post", 'service-fee-device-group/save', 'id', 'name', 'package_id', 'operator_id'],
		remark: ["Post", 'service-fee-device-group/set-remark', 'id', 'remark'],
		detail: ["Post", 'service-fee-device-group/detail', 'id'],
		detailByOperator: ["Post", 'service-fee-device-group/detail-by-operator'],
		delete: ["Post", 'service-fee-device-group/delete', 'id'],
		updateStatus: ["Post", 'service-fee-device-group/set-flag-charge', 'id', 'ids'], // 更改分组的是否收取的状态
	},
	// 服务费 收费分组下的设备 | 已迁移：module/service-charge.js
	ServiceChargeGroupItem: {
		option: ["Post", 'device/get-device-for-service-fee', 'page', 'page_size', 'uid', 'operator_id'],
		list: ["Post", 'service-fee-device-group-item/list', 'page', 'group_id', 'device_uid', 'sort'],
		add: ["Post", 'service-fee-device-group-item/save-device', 'group_id', 'uids'], // 批量添加设备
		sync: ["Post", 'service-fee-device-group-item/sync-operator-device', 'operator_id'], // 同步运营商设备
		import: ["Post", 'service-fee-device-group-item/import-group-device', 'group_id', 'operator_id', 'file'], // 批量导入设备
		remove: ["Post", 'service-fee-device-group-item/delete-device', 'ids'], // 批量删除设备

		gatewayList: ["Post", 'service-fee-device-group-item/add-gateway-list', 'page', 'group_id'], // 添加网关 - 网关列表
		deviceList: ["Post", 'service-fee-device-group-item/add-device-list', 'page', 'page_size', 'group_id', 'uid'], // 添加设备 - 设备列表

		detail: ["Post", 'service-fee-device-group-item/detail', 'operator_id', 'device_uid'],
		transfer: ["Post", 'account/device-service-fee-transfer', 'from_device_uid', 'to_device_uid', 'operator_id'], // 转移设备服务费

		// 设备服务费金额变动记录
		moneyList: ["Post", 'device-account-money/device-account-detail-list', 'page', 'device_uid', 'subject', 'begin_time', 'end_time'],
	},
	// 服务费 收取订单 | 已迁移：module/service-charge.js
	ServiceChargeOrder: {
		orderList: ["Post", 'service-fee-order/list', 'page', 'operator_id', 'device_uid', 'begin_time', 'end_time', 'version'],

		// rechargeList: ['device-account-money/service-fee-online-pay-in-detail-list', 'page', 'order_sn', 'operator_id', 'start_time', 'end_time'],
		// rechargeDetails: ['charge-order/detail', 'page', 'order_id'],
		
		// 线上支付记录 TODO
		// rechargeList: ['charge-order/list', 'type', 'page', 'operator_id', 'org_id', 'order_sn', 'outer_sn', 'user_name', 'user_phone', 'clearing_status', 'charge_type', 'status', 'pay_method', 'card_uid', 'begin_time', 'end_time'],
		rechargeList: ["Post", 'device-account/service-fee-charge-order-list', 'page', 'operator_id', 'order_sn', 'begin_time', 'end_time', 'status'], // new
		rechargeDetails: ["Post", 'device-account-money/recharge-detail', 'charge_order_id'], // 线上支付记录 的详情 具体支付的设备
		rechargeDetailList: ["Post", 'device-account-money/recharge-detail-list', 'charge_order_id', 'page'],

		// 待审核订单处理
		confirmPendingOrder: ["Post", 'charge-order/confirm-pending-order', 'charge_order_id'], // 确认待确认订单（设备账户已入账）
		refundPendingOrder: ["Post", 'charge-order/refund-pending-order', 'charge_order_id'], // 退款待确认订单（设备账户未入账）
		auditLogList: ["Post", 'charge-order/action-list', 'charge_order_id', 'page'], // 审核操作日志
	},
	// 服务费 收付款账户 | 已迁移：module/service-charge.js
	ServiceChargeAccount: {
		list: ["Post", 'account/service-fee-list', 'page', 'sort', 'operator_id', 'group_name', 'flag_service_rate', 'version'],
		deatil: ["Post", 'account/service-fee-account-detail', 'user_id', 'version'],

		detailList: ["Post", 'account-money/account-service-fee-list', 	        'page', 'operator_id', 'type', 'begin_time', 'end_time', 'version'],
		collectList: ["Post", 'account-money/collect-account-service-fee-list', 'page', 'operator_id', 'type', 'begin_time', 'end_time', 'version'],

		// 向收款账户充值
		createOrder: ["Post", 'account/recharge-account', 'account_id', 'price', 'pay_method', 'version'], // 账户充值 - 生成支付链接
		createOrderByDevice: ["Post", 'device-account/create-device-account-recharge-order', 'operator_id', 'uids', 'org_ids', 'flag'], // TODO 根据选择的设备 生成对应的 服务费支付链接
	},

	// 服务费订单 | 已迁移：module/service-charge.js
	ServiceOrder: {
		list: ["Post", 'service-fee-pay-order/list', 'page', 'from_operator_id', 'to_operator_id', 'begin_time', 'end_time'],
		listSub: ["Post", 'service-fee-pay-order/list-sub', 'page', 'from_operator_id', 'to_operator_id', 'begin_time', 'end_time'],
		detail: ["Post", 'service-fee-pay-order/detail', 'id'],

		orderPay: ["Post", 'pay/device-account-recharge-order-pay', 'order_sn', 'outer_user_id'], // 支付订单
		orderCancel: ["Post", 'pay/device-account-recharge-order-cancel', 'order_sn'], // 取消订单
	},

	// 微信小程序独立部署 | 已迁移：module/common.js
	WxPlatform: {
		getCode: ["Post", 'wax/get-pre-code'],
		commit: ["Post", 'wax/commit', 'appid', 'user_version', 'user_desc', 'template_id', 'ext_json'], // 上传代码
		submit: ["Post", 'wax/submit', 'appid'], // 提交审核
		qrCode: ["Post", 'wax/get-try-qr-code', 'appid'],
		check: ["Post", 'wax/query-last-audit-status', 'appid'], // 检查审核状态
		release: ["Post", 'wax/release', 'appid'],

		setPrivacy: ["Post", 'wax/set-privacy-setting', 'appid', 'privacy_ver', 'owner_setting', 'setting_list'],
		getPrivacy: ["Post", 'wax/get-privacy-setting', 'appid', 'privacy_ver'],
	},
	// 已迁移：module/common.js
	Notify: {
		notify: ["Post", 'notify', 'auth_code', 'expires_in'],
	},

	// 广告配置 | 已迁移：module/marketing.js
	Advertising: {
		list: ["Post", 'ad_config/list', 'page', 'scene', 'vendor', 'begin_time', 'end_time'],
		save: ["Post", 'ad_config/save', 'id', 'scene', 'score', 'url', 'vendor', 'begin_time', 'end_time'],
		delete: ["Post", 'ad_config/delete', 'id'],

		log: ["Post", 'ad_log/list', 'page', 'resource_id', 'ad_id', 'channel', 'type', 'user_id', 'begin_time', 'end_time'],
	},
	// 广告规则 | 已迁移：module/marketing.js
	AdverRule: {
		list: ["Post", 'ad-rule/list', 'page', 'begin_time', 'end_time'],
		save: ["Post", 'ad-rule/save', 'id', 'operator_id', 'org_id', 'station_id', 'device_id', 'config'],
		detail: ["Post", 'ad-rule/detail', 'operator_id', 'org_id', 'station_id', 'device_id'],
		delete: ["Post", 'ad-rule/delete', 'id'],
		batchDelete: ["Post", 'ad-rule/batch-delete', 'ids'],
	},
    // 保险订单 - 自燃险 - C端购买 | 已迁移：module/marketing.js
	Insurance: {
		list: ["Post", 'insurance/list', 'page', 'order_sn', 'status', 'begin_time', 'end_time'],
		refund: ["Post", 'insurance/refund', 'id'],
		preOrder: ["Post", 'insurance/alipay-insurance-pre-order', 'id'],
		advanceOrder: ["Post", 'insurance/alipay-insurance-sync', 'id'],

		detail: ["Post", 'insurance/detail', 'order_sn', 'order_type'],
	},
    // 保险订单 - 场地险 - B端购买 | 已迁移：module/marketing.js
	VenueInsurance: {
		list: ["Post", 'insurance/list-operator', 'page', 'name', 'status', 'suid', 'begin_time', 'end_time'],
		remark: ["Post", 'insurance/set-mark', 'id', 'data'],
	},
	// 错误日志 | 已迁移：module/message.js
	ErrorLog: {
		list: ["Post", 'error-log/list', 'page', 'channel', 'type', 'begin_time', 'end_time', 'suid'],
		teamVinStartErrorList: ["Post", 'error-log/team-vin-start-error-list', 'card_uid', 'page', 'page_size'],
	},

	// 系统消息 - 反馈工单 | 已迁移：module/feedback.js
	Feedback: {
		overview: ["Post", 'ticket/overview', 'operator_id'], // 总览
		statProgress: ["Post", 'ticket/stat-progress', 'uid', 'scene', 'status', 'progress', 'operator_id', 'card_uid', 'charge_order_sn', 'contract_phone', 'begin_time', 'end_time'], // 进度统计
		list: ["Post", 'ticket/list', 'page', 'sort', 'uid', 'scene', 'status', 'progress', 'progress_list', 'operator_id', 'card_uid', 'charge_order_sn', 'contract_phone', 'begin_time', 'end_time'],
		detail: ["Post", 'ticket/detail', 'id'],
		detailByUid: ["Post", 'ticket/detail-by-uid', 'uid'],
		comment: ["Post", 'ticket/comment', 'id', 'comment'], // 评论
		actionList: ["Post", 'ticket/action-list', 'page', 'id', 'types'], // 操作列表
		process: ["Post", 'ticket/process', 'id', 'remark'], // 处理工单
		updateRemark: ["Post", 'ticket/update-remark', 'id', 'remark'], // 更新工单备注
		close: ["Post", 'ticket/close', 'id'], // 关闭工单
		
		queryChargingOrder: ["Post", 'order/query-charging-order', 'card_uid'], // 查询卡片是否存在进行中订单
		detailByCardUid: ["Post", 'ticket/detail-by-card-uid', 'card_uid', 'card_type'], // 通过卡号查询反馈详情 - 查询充值订单是否提交退款申请

		// 开票申请
		childList: ["Post", 'ticket/list-children', 'id', 'page'], // 子工单
		chargeOrderList: ["Post", 'order/list', 'page', 'ids'], // 充电订单
		insuranceOrderList: ["Post", 'insurance/list', 'page', 'order_ids'], // 安心充订单
		detailByOrderId: ["Post", 'ticket/detail-by-order-id', 'order_id'], // 查询充电订单是否提交开票申请
		detailByInsuranceIds: ["Post", 'ticket/query-uid-by-insurance-ids', 'insurance_ids'], // 查询安心充订单是否提交开票申请
	},

	// 黑名单 | 已迁移：module/common.js
	BlackPanel: {
		save: ["Post", 'black-panel/save', 'user_type', 'type', 'operator_id'],
		list: ["Post", 'black-panel/list', 'page', 'user_type', 'type', 'operator_id'],
		delete: ["Post", 'black-panel/delete', 'black_panel_id'],
		batchDelete: ["Post", 'black-panel/delete-batch', 'black_panel_ids'],
        findbBlackPanelByOperator: ["Post", 'black-panel/find-black-panel-by-operator', 'user_type', 'type', 'operator_id'],

		create: ["Post", 'black-panel/create', 'user_type', 'type', 'operator_id', 'orgId', 'user_phone', 'username'], // 黑名单创建
		update: ["Post", 'black-panel/update', 'id', 'username'], // 黑名单修改
		actionList: ["Post", 'black-panel/action-list', 'operator_id', 'org_id', 'user_id', 'page'], // 黑名单操作记录
	},
	
	// 组织管理 | 已迁移：module/team.js
	Team: {
		save: ["Post", 'team/save', 'id', 'name', 'tax_no', 'registered_address', 'contact_person', 'contact_phone', 'remark'],
		delete: ["Post", 'team/delete', 'id'],
		list: ["Post", 'team/list', 'page', 'name', 'phone', 'team_id', 'operator_id' ],
		detail: ["Post", 'team/detail', 'id'],
		bind: ["Post", 'team-bind/batch-bind', 'target_id', 'team_ids', 'target_type', 'overwrite'],
		unbind: ["Post", 'team-bind/batch-unbind', 'target_id', 'team_ids', 'target_type'],
		bindList: ["Post", 'team-bind/bind-list', 'page', 'target_id', 'target_type'],
		createVirtualCard: ["Post", 'team/create-virtual-card', 'team_id', 'type', 'money', 'remark', 'pre_pay_money'],
		virtualCardList: ["Post", 'team/get-virtual-cards', 'team_id'],
		setCardStatus: ["Post", 'team/set-card-status', 'card_id', 'status'],
		setVirtualCardPrePayMoney: ["Post", 'team/set-virtual-card-pre-pay-money', 'card_id', 'pre_pay_money'],
	},
	// 组织成员 | 已迁移：module/team.js
	TeamMember: {
		save: ["Post", 'team-member/save', 'id', 'team_id', 'name', 'phone', 'vin_code', 'plate_number', 'vehicle_brand', 'monthly_charge_limit', 'use_type', 'remark'],
		delete: ["Post", 'team-member/delete', 'id'],
		batchDelete: ["Post", 'team-member/batch-delete', 'ids'],
		list: ["Post", 'team-member/list', 'page', 'team_id', 'name', 'phone', 'vin_code', 'plate_number'],
		detail: ["Post", 'team-member/detail', 'id'],
	},
	// 权益包订单管理 | 已迁移：module/operator.js
	BenefitPackageOrder: {
		create: ["Post", 'benefit-package-order/create', 'amount', 'price'],
		list: ["Post", 'benefit-package-order/list', 'page', 'status'],
		detail: ["Post", 'benefit-package-order/detail', 'id'],
	},
	// SSO
	Sso: {
		createTicket: ["Post", 'sso/create-ticket', 'name'],
	},
	// 设备故障告警
	DeviceFault: {
		badge: ["Post", 'device-fault/badge'],
	},

};

export default new Api(apiList);
